import './hijackJump';
import { setupRemoteApps } from './injected-module-app';

setupRemoteApps().then(() => {
  import('./bootstrap.js');
});
